import { mockStoreProduct } from '@innogy/feh/models';

export const mockStoreReceiptViewModel = {
  selectedProducts: [mockStoreProduct],
};
